import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpToLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-arrow-up-to-line-icon lucide-arrow-up-to-line", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 3h14" }), /* @__PURE__ */ React.createElement("path", { d: "m18 13-6-6-6 6" }), /* @__PURE__ */ React.createElement("path", { d: "M12 7v14" }));
const ForwardRef = forwardRef(SvgArrowUpToLine);
export { ForwardRef as ReactComponent };
